<template>
  <div class="wrap">
    <img
      @click="toDownload"
      class="btn"
      :class="{isManager:isManager}"
      src="@/assets/img/btn.png"
      alt="btn"
      v-if="showLogo"
    />
    <div v-if="!showLogo" class="btn down" :class="{isManager:isManager}" @click="toDownload">立即下载</div>
    <img class="bg" src="@/assets/img/bg.png" alt="bg" />
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
const scheme = {
    '1682d3a2ee0c4ee8acbe58a5c39bb888':'im87aa64',    //A01
    'PcTfdNK4EdJvxLpbvoV8Kn2798OrtxE2':"im87aa68",    //A02
    'PCHas53duTI4rGn45WSWRM2Dnv0XWvxc':"im87aa62",    //A04
    'TdmLxxLAMxkVG7JFJ5S5I5EfZI49qS2X':"im87aa66",    //A05
    'd0670969d3e5403d906e21f1a4e77913':"im87aa70",    //E04
    'a80db5262e14467b82d6dec666073364':"im87aa72",    //H86
    'f11230926baf45578f2b77c9579d8275':'im87aa74',  //HX1
    'a6ydgchQ0gGY5NTGd70uMg3jR9wfgQBi':'im87aa76',  //C08
}
export default {
  name: 'Landing',
  data() {
    return {
      showLogo: false,
      appInfo: {
        productId: '',
        isIOS: false,
      },
      appDownloadUrl: '',
      isManager:false,
    }
  },
  async mounted() {
    const productId = this.$route.query.productId
    const isManager =  this.$route.query.manager    //判断是否是经理
    const mode = this.$route.query.mode
    var url = mode !== 'dev' ? '/app/download' : '/imapp/app/download'
    if(isManager){
        url = '/app/managerApp/download'
        this.isManager = true
    }
    if(process.env.NODE_ENV=='development'){
        url = 'http://public-im-api-fat.k8s-fat.com' + url
    }
    const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

    this.appInfo.productId = productId
    this.appInfo.isIOS = isIOS
    this.showLogo = productId === 'PCHas53duTI4rGn45WSWRM2Dnv0XWvxc'

    if (productId) {
      // 经理分享的链接
      if(this.$route.query.mid){
        this.wakeUpApp()
      }
      // try {
        
        const { body, head } = await this.postData(url, { productId })
        if (!body) {
          alert(head.errMsg)
        }
        // let body = {
        //     "iosAppDownUrl": "http://sdfrwerwerwewerwer111123333.com?signid=1;http://sdfrwerwerwewerwer111123331.com;http://sdfrwerwerwewerwer111123332.com;https://34.92.95.91:9400/#/Index?appCode=CF5AW2m",
        //     "iosVersionCode": "1.1.1",
        //     "androidAppDownUrl": "https://11111oye.aa00a1.com/resource/app/customer_runtimeTest_release_A02_1.1.0.apk;https://tbi.aaba00.com/resource/app/customer_runtimeTest_release_A02_1.1.0.apk;https://down.aaz01a.com/resource/app/customer_runtimeTest_release_A02_1.1.0.apk;http://ph.ips2.io/resource/app/customer_runtimeTest_release_A02_1.1.0.apk",
        //     "androidVersionCode": "1.8.0"
        // }

        const signid = this.$route.query.signid

        let iosUrl = body?.iosAppDownUrl.split(';')
          if(signid && iosUrl.filter(x=> x.includes('signid='+signid)).length>0){
            iosUrl = iosUrl.filter(x=> x.includes('signid='+signid))
          }
          
        let androidUrl = body?.androidAppDownUrl.split(';')
          if(signid && androidUrl.filter(x=> x.includes('signid='+signid)).length>0){
            androidUrl = androidUrl.filter(x=> x.includes('signid='+signid))
          }
          
        let urlList = []
        if (isIOS) {
          this.appDownloadUrl = iosUrl[0]
          urlList = iosUrl.map((item) => {
            if(item.includes('signid')){
              return item
            }else{
              return new URL(item).origin
            }
          })
        } else {
          // 预设先抓第一个
          this.appDownloadUrl = androidUrl[0]
          urlList = androidUrl.map((item) => {
            if(item.includes('signid')){
              return item
            }else{
              return new URL(item).origin
            }
          })
        }
        console.log('urlList',urlList)
          // 开始测速
          let _getArray = []

          if (_.isArray(urlList) && _.size(urlList) > 0) {
            const CancelToken = axios.CancelToken
            const source = CancelToken.source()
            _.forEach(urlList, (u) => {
              _getArray.push(
                new Promise((resolve, reject) => {
                  let newUrl = u.includes('signid') ? u : `${u}/domain_status/`
                  axios
                    .get(newUrl, { cancelToken: source.token })
                    .then((res) => {
                      resolve(u)
                      if (res) {
                        source.cancel('fast domain is returned')
                      }
                    }).catch(err=>{
                      resolve(false)
                    })
                })
              )
            })
            this.$loading.show()
            Promise.all([..._getArray]).then((promises) => {
              console.log('promises',promises)
              if(promises.find(x=>x)){
                let domain = promises.find(x=>x)
                if (isIOS) {
                  this.appDownloadUrl = iosUrl.find(x=>x.includes(domain))
                }else{
                  this.appDownloadUrl = androidUrl.find(x=>x.includes(domain))
                }
                console.log(`Final url: ${this.appDownloadUrl}`)
              }else{
                console.log('All speed test failed, use default url')
              }
              this.$loading.close()
            }).catch(err=>{
              console.log('错误',err)
              this.$loading.close()
            })
          }
        // }
      // } catch (e) {
      //   console.log(e)
      // }
    } else {
      console.log('productId is undefined')
    }
  },
  methods: {
    postData(url, data) {
      return fetch(url, {
        body: JSON.stringify(data), // must match 'Content-Type' header
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, same-origin, *omit
        headers: {
          'user-agent': 'Mozilla/4.0 MDN Example',
          'content-type': 'application/json',
        },
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      }).then((response) => response.json())
    },
    async toDownload() {
      let mid = this.$route.query.mid
      let group = this.$route.query.group
      if(mid){
        let url = scheme[this.appInfo.productId]+'://?targetId='+mid
        if (group) {
          url = scheme[this.appInfo.productId]+'://?targetId='+mid + '&group=' + group
        }
        try {
          await this.$copyText(url)
          // await navigator.clipboard.writeText(mid);
          console.log('Content copied to clipboard');
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
      }
      
      if (!this.appInfo.productId) {
        alert('productId is undefined')
        return
      }
      if (this.appDownloadUrl === '') {
        alert('当前无可用线路，请刷新页面重试')
        return
      }
      window.location.href = this.appDownloadUrl
    },
    wakeUpApp(){
        // const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      let mid = this.$route.query.mid
      let group = this.$route.query.group
      let url = scheme[this.appInfo.productId]+'://?targetId='+mid
      if (group) {
        url = scheme[this.appInfo.productId]+'://?targetId='+mid + '&group=' + group
      }
      console.log(url)
      const userAgent = navigator.userAgent;
      let isSafari = false
      if(/safari/gi.test(userAgent) && !/(crios|Chrome|chrome|fxios|qqbrowser|sogou|baidu|ucbrowser|qhbrowser|opera|micromessenger|weibo)/gi.test(userAgent)){
          isSafari = true
      }
      // 苹果只能用 isSafari 浏览器打开  安卓不需要判断
      if(userAgent.match(/iPhone|iPad|iPod/i) && !isSafari){
        return
      }
      setTimeout(() => {
        window.location = url
      }, 500);
    }
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;
  max-width: 768px;
  margin: 0 auto;
}
.bg {
  width: 100%;
}
.btn {
  width: 275px;
  height: 82px;
  position: absolute;
  bottom: 45px;
  left: 50%;
  transform: translate(-50%);
  box-shadow: 0 5px 8px 0 rgba(57, 43, 8, 0.26);
  border-radius: 16.8px;
  &:hover {
    cursor: pointer;
  }
  &.isManager{
      box-shadow: 0px 0px 8px 0 rgba(#fff,0.8);
  }
}
.down {
  font-size: 40px;
  text-align: center;
  /* line-height: 60px; */
  /* margin-top: 10px; */
  /* padding-top: 10px; */
  line-height: 82px;

  /* color: #ff9; */
  background: darkgoldenrod;
  color: #edd;
}
</style>
